import createAdjDetailEntry from './createAdjDetailEntry'
import isReadonlyFatigueAdj from './isReadonlyFatigueAdj'
import isEmpty from './isEmpty'

function normaliseAdjKeyPart(value) {
  return String(value ?? '')
    .trim()
    .replace(/\s+/g, ' ')
    .toLowerCase()
}

function normaliseAdjCharacterItem(adj) {
  if (!adj) {
    return null
  }

  if (adj.character_item && typeof adj.character_item === 'object') {
    return adj.character_item
  }

  const itemId = adj.character_item ?? adj.item_id ?? null
  const itemName = adj.item_name ?? null

  if (itemId != null && itemName) {
    return {
      id: itemId,
      name: itemName,
    }
  }

  return itemId
}
//---------------------------
// create adj detail harness
//---------------------------
export default function createAdjDetailHarness({ adj, adjs, source, character } = {}) {
  console.log('--------------------------')
  console.log('IN createAdjDetailHarness')
  // console.log('adj:', adj)
  // console.log('adjs:', adjs)
  // console.log('source:', source)
  // console.log('character:', character)
  /*
  ADJ SOURCES
  -----------
  A. character.skills.character_skill_adjs e.g. +10 Stealth [CharacterSkillAdjs]
  B. character.skills.characteristic_skill_adjs e.g. -5 armour dex pen [CharacteristicSkillAdjs]
  C. character.skills.integrated_rune_skill_adjs e.g. +5 Stealth from Shadow Rune [RuneSkillAdjs]
  */
  //---------
  // defense
  //---------
  if (
    isEmpty(adj) ||
    adjs === undefined ||
    adjs === null ||
    isEmpty(source) ||
    isEmpty(character)
  ) {
    console.error('createAdjDetailHarness: missing required parms')
    return null
  }
  //----------
  // declares
  //----------
  adj.character_item = normaliseAdjCharacterItem(adj)
  let entry_reason = ''
  let entry = null
  let rune_name = ''
  let editable_ind = false
  //==========================================================================================
  // A. CHARACTER SKILL ADJS (specific skill adj can be associated with a rune)
  //=========================
  if (source === 'character') {
    console.log('A. Source is CHARACTER SKILL ADJ')
    //-------------------------------------------------
    // manual character skill adjs remain editable after
    // reload even when the user linked them to an item.
    // only system-derived fatigue rows stay readonly.
    //-------------------------------------------------
    if (isReadonlyFatigueAdj(adj.adj_reason)) {
      editable_ind = false
    } else {
      editable_ind = true
    }
    rune_name = adj.rune_name || ''
    //--------------------------------------------------------------------------------
    // for character skill adjs - set name to rune name if exists where 'runecasting'
    //--------------------------------------------------------------------------------
    // console.log('rune_name = ', rune_name)
    // console.log('adj.name = ', adj.name)

    if (rune_name !== '' && adj.name === 'Runecasting') {
      adj.name = rune_name
      // console.log('UPDATED adj.name to rune_name = ', adj.name)
    }
    //--------------------------
    // set entry reason for adj
    //--------------------------
    entry_reason = adj.adj_reason.charAt(0).toUpperCase() + adj.adj_reason.slice(1)
    //==========================================================================================
    // B. CHARACTERISTIC SKILL ADJS
    //==============================
  } else if (source === 'character_direct') {
    console.log('B. Source is DIRECT CHARACTERISTIC ADJ')
    //-------------------------------------------------
    // Direct characteristic adjs are editable unless they
    // are system-derived, such as fatigue. A linked item
    // can still be a user-editable association.
    //-------------------------------------------------
    if (isReadonlyFatigueAdj(adj.adj_reason)) {
      editable_ind = false
    } else {
      editable_ind = true
    }
    rune_name = adj.rune_name || ''
    //--------------------------
    // set entry reason for adj
    //--------------------------
    entry_reason = adj.adj_reason.charAt(0).toUpperCase() + adj.adj_reason.slice(1)
    //===============================================================================
    // B2. CHARACTERISTIC SKILL ADJS
    //===============================
  } else if (source === 'characteristic') {
    console.log('B2. Source is CHARACTERISTIC SKILL ADJ')
    //-------------------------------------------------
    // Characteristic-derived skill adjs such as armour
    // dex penalties remain readonly after reload.
    //-------------------------------------------------
    editable_ind = false
    rune_name = adj.rune_name || ''
    //--------------------------
    // set entry reason for adj
    //--------------------------
    entry_reason = adj.adj_reason.charAt(0).toUpperCase() + adj.adj_reason.slice(1)
    //===============================================================================
    // C. INTEGRATED-RUNE SKILL ADJS
    //===============================
  } else if (source === 'integrated_rune') {
    console.log('C. Source is INTEGRATED RUNE SKILL ADJ')
    // console.log('createAdjDetailHarness: processing integrated rune skill adj = ', adj)
    // console.log('1. adj.rune_name = ', adj.rune_name)
    // console.log('2. adj.name = ', adj.name)
    //-----------
    // set flags
    //-----------
    editable_ind = false
    rune_name = adj.rune_name || ''
    let reason_name = ''
    //--------------------------
    // set entry reason for adj
    // prefer explicit adj.adj_reason (e.g. 'Air Rune (Jump)')
    // then rune_name, then adj.name as fallbacks
    //--------------------------
    if (adj.name === 'Runecasting' && !isEmpty(rune_name)) {
      reason_name = rune_name
    } else if (!isEmpty(adj.adj_reason)) {
      reason_name = adj.adj_reason
    } else if (!isEmpty(rune_name)) {
      reason_name = rune_name
    } else {
      reason_name = adj.name
    }
    if (!isEmpty(reason_name)) {
      entry_reason = reason_name.charAt(0).toUpperCase() + reason_name.slice(1)
    }
    console.log('3. entry_reason = ', entry_reason)
    //--------------------
    // append runecasting (only once)
    //--------------------
    if (adj.name === 'Runecasting' && !entry_reason.includes('(Runecasting)')) {
      entry_reason += ' (Runecasting)'
    }
    console.log('4. FINAL entry_reason = ', entry_reason)
    //===============================================================================
    // catch source error
    //--------------------
  } else {
    console.error('createAdjDetailHarness: invalid source parm = ', source)
    return character
  }
  //=================================================================================
  // create adj detail entry
  //-------------------------
  if (entry_reason !== '') {
    // console.log('4b. adj.id = ', adj.id)
    //-----------------------------------------------
    // determine applied flag for detail entry
    // - for integrated rune adjs:
    //     * if backend sets adj.applied, honour it
    //     * if adj.applied is undefined, treat as applied (true)
    // - for other sources, default to boolean(adj.applied)
    //-----------------------------------------------
    const appliedFlag =
      source === 'integrated_rune'
        ? adj.applied !== undefined
          ? adj.applied
          : true
        : !!adj.applied
    //--------------
    // safety check
    //--------------
    if (!character.skill_adjs) {
      console.warn('character.skill_adjs not found - initialising to empty array')
      character.skill_adjs = []
    }
    // console.log('4c. check if adj already exists in character.skill_adjs')
    // console.log('4d. character.skill_adjs = ', character.skill_adjs)
    const entryNameKey = normaliseAdjKeyPart(adj.name)
    const entryReasonKey = normaliseAdjKeyPart(entry_reason)
    let adj_exists = character.skill_adjs.some(
      (a) =>
        normaliseAdjKeyPart(a.name) === entryNameKey &&
        normaliseAdjKeyPart(a.adj_reason) === entryReasonKey,
    )
    //--------------------------------------------
    // skip where adj detail entry already exists
    //--------------------------------------------
    console.log('5. adj_exists = ', adj_exists)
    if (adj_exists) {
      console.log('6. adj detail entry already exists - skipping creation')
      //-------------------------------------------------------------
      // ensure existing entry has character_item where now available
      //-------------------------------------------------------------
      const existing = character.skill_adjs.find(
        (a) =>
          normaliseAdjKeyPart(a.name) === entryNameKey &&
          normaliseAdjKeyPart(a.adj_reason) === entryReasonKey,
      )

      if (existing) {
        existing.adj_value = adj.adj_value
        existing.applied = appliedFlag

        if (source !== 'character' || isReadonlyFatigueAdj(adj.adj_reason)) {
          existing.editable = false
          existing.source = source
        }
      }

      if (adj.character_item) {
        if (existing && !existing.character_item) {
          existing.character_item = adj.character_item
          // console.log(
          //   '6b. updated existing adj detail entry with character_item = ',
          //   existing.character_item,
          // )
        }
      }
    } else {
      console.log('7. adj detail entry does not exist - creating now')
      entry = createAdjDetailEntry({
        id: adj.id,
        name: adj.name,
        adj_reason: entry_reason,
        adj_value: adj.adj_value,
        character_item: adj.character_item ? adj.character_item : null,
        editable: editable_ind,
        rune: rune_name,
        source: source,
        applied: appliedFlag,
      })
    }
  }
  return entry
}
